

import Vue from 'vue';
import { Component, Model, Prop, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex/types/helpers';
import { Chip } from  '@/models/repsol-template.model';
import { tUi } from '@/utils/translate';

@Component({
    name: 'RepsolFilterChipsComponent',
    components: {
            }
})

export default class RepsolFilterChipsComponent extends Vue {
    @Prop()
    filterChips : Chip[];

    translate(value: string, params?: Record<string, unknown>): string {
        return tUi(value, params);
    }

    removeChip(clave: string): void {
        this.$emit("removeChip", clave);
    }

    mostrarNombreChip(value:any){
        if (value == null) {
            return '';
        }

        if (typeof value === 'string') {
            return this.translate(value);
        }

        return this.translate(value.nombre ?? value.name ?? value.id ?? '');
    }
}

Vue.component('repsol-filter-chips', RepsolFilterChipsComponent);
